import React, {useEffect, useRef, useState} from "react";
import "../../../styles/products-styling/cleaned/product.css";
import HeaderComponent from "../headerComponent";
import InformationCard from "../informationCard";
import HorizontalMiniCards from "../horizontalMiniCards";
import Divider from "../../generalComponents/divider";
import CTABanner from "../../generalComponents/banners/CTABanner";
import AdvanceCTABanner from "../../generalComponents/banners/advanceCTABanner";
import {BuiltForShopifyBadge, FacebookAdGraphic1, FacebookAdGraphic2, FacebookAdGraphic3} from "../../../assets/assets";
import {ArrowRightIcon} from "@heroicons/react/16/solid";
import {useLocation} from "react-router-dom";
import TestimonialComponent from "../../home/TestimonialComponent";
import TestimonialsSection from "../testimonialsSection";
import {sendSlackMessageTracked} from "../../../models/notifications";
import SecondaryPricingComponent from "../../SecondaryPricingComponent";
import ModernPricingView from "../../pricing/modernPricingView";
import CarouselComponent from "../../CarouselComponent";
import MainPopupForm from "../../popupModules/mainPopupForm";

const CashbackInfoComponent = () => {
  const location = useLocation();

  const cashbackRef = useRef();
  const results = useRef();
  const getStarted = useRef();

  const [hash, setHash] = useState();

 useEffect(() => {
    const hash = location.hash;
    setHash(hash)
    sendSlackMessageTracked("Lead is visiting the Cashback Info page.", "#website-updates")
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' }); // or 'smooth' if you want animation
  }, []);

  // Scroll handler
  useEffect(() => {
    let referenceObject = null;
    let blockPosition = "start"
    if (hash) {
      switch (hash) {
        case "#cashback":
          referenceObject = cashbackRef;
          blockPosition = "start"
          break
        case "#results":
          referenceObject = results;
          blockPosition = "start"
          break
        case "#get-started":
          referenceObject = getStarted;
          blockPosition = "start"
          break
      }
      if (referenceObject) {
        referenceObject.current.scrollIntoView({
          behavior: 'smooth', // Optional: Add smooth scrolling
          block: blockPosition
        });
      }
    }
  }, [hash]);


  return (
   <div
      className="page-template page-template-elementor_header_footer page
      page-id-1652 wp-custom-logo elementor-default
      elementor-template-full-width elementor-kit-159 elementor-page
      elementor-page-1652"
      // style={{ background: `#f9fafb` }}
    >
      <div
          data-elementor-type="wp-page"
          data-elementor-id={1652}
          className="elementor elementor-1652"
          data-elementor-post-type="page"
      >
        <HeaderComponent title="🚀What Differentiates Small Business and Big Business"
                         
                         subtitle={<div>A quiet engine behind client loyalty, Shopify cashback subtly drives growth by turning everyday purchases into 
                          future opportunities.&nbsp;<span className="italic">Discover why major brands use cashback&nbsp;</span>
                         </div>}
                         items={[
                           {text: "💸 Cashback", ctaURL: "#cashback"},
                           {text: "📈 Results", ctaURL: "#results"},
                           {text: "🔨 Get Started", ctaURL: "#get-started"}
                         ]}
        />

        <div ref={cashbackRef} className="scroll-mt-32 space-y-12">
          <InformationCard
              // image="https://planzer.io/wp-content/uploads/2023/01/62d5698a920dec3f3e45bcbf_tasks-solved.svg"
              // image={FacebookAdGraphic3}
              image="https://web.archive.org/web/20230420133841im_/https://cdn.shopify.com/shopifycloud/brochure/assets/merchants/snowdevil/snowdevil-about-online-store-sustainability@desktop-2x-58cb709c01464fee88750e78a3ea221c1f9e05c07611a2be28dd43bcfa80ab39.png"
              // imageDirection="left"
              imageDirection="right"
              text="🧐 What is cashback & who does it? "
              ctaURL="/products/cashback"
              ctaString="Get started with Cashback"
              subtext={
                <div>
                  Cashback is a rewards system where customers earn a portion of their purchase back, often as store credit. It's used by businesses to drive repeat purchases, boost customer lifetime value,
                  and reduce reliance on discounted. Successful companies like Amazon, Starbucks, and fashion retailers use cashback to keep customers engaged and loyal.
                  <br/><br/>
                 
                </div>
              }
          />


          <div className="flex justify-center">
            <CTABanner
                text="Ready to start planning your cashback?" ctaURL="/pricing" ctaString="Select program"
            />
          </div>

          <div ref={results} className="mt-32">
          <InformationCard
              // image={FacebookAdGraphic1}
              image={"https://www.enactsoft.com/resources/wp-content/uploads/2025/02/visual-selection-7.png"}
              imageDirection="left"
              ctaURL="/products/cashback"
              ctaString="Learn more about Cashback"

              text="Does cashback increase Shopify sales?"
              text="Shopify cashback app with automated payouts"
              text="Shopify cashback app free trial"
              subtext={<div>
                More sales, bigger orders, and repeat customers. Shoppers come back to use their store credit, keeping them engaged and spending. 
                This allows for businesses to grow without relying on constant discounts.
                Businesses implementing cashback programs see a 30% increase in repeat purchases and a 20% rise in order value. 
                Additionally, cashback programs boost customer lifetime value (CLV) by 15%, with 60% of customers more likely to make a repeat purchase when cashback is involved. 
                Customers also report feeling more loyal to brands offering cashback, with 70% of shoppers stating a stronger connection to those brands.

                <br/><br/>
                
              </div>
              }
          />
</div>
        </div>

        <HorizontalMiniCards items={[
          {
            text: "Repeat Purchases",
            subtext: "Businesses implementing cashback programs see a 30% increase in repeat purchases, which also nutures loyal customers",
            image: "https://planzer.io/wp-content/uploads/2023/01/Recurring-tasks-icon.png",
            ctaURL: "/products/cashback",
          },
          {
            text: "Higher Order Value",
            subtext: "Using cashback often boosts average order value by 20%—shoppers add more to their carts knowing they'll earn store credit in return.",
            image: "https://planzer.io/wp-content/uploads/2023/01/Add-to-backlog-icon.png",
            ctaURL: "/products/cashback",
          },
          {
            text: "Longer CLV",
            subtext: "Cashback programs boost customer lifetime value (CLV) by 15%, with 60% of customers more likely to make a repeat purchase when cashback is involved.",
            image: "https://planzer.io/wp-content/uploads/2023/01/Filter-by-tags-icon.png",
            ctaURL: "/products/cashback",
          },
        ]}/>

        <div className="flex justify-center">
          <div className="w-3/4">
            <Divider/>
          </div>
        </div>


        <div ref={getStarted} className="space-y-12 mb-8">
          <InformationCard
              // image="https://planzer.io/wp-content/uploads/2023/01/62d5698a920dec3f3e45bcbf_tasks-solved.svg"
              // image={FacebookAdGraphic3}
              image="https://www.enactsoft.com/resources/wp-content/uploads/2025/02/visual-selection-6-2048x1429.png"
              // imageDirection="left"
              imageDirection="right"
              // text="🧨 Over-reliance on discounts."
              text="🚀 How to add cashback to Shopify store?"
              // ctaURL="/products/cashback"
              // ctaString="Learn more about Cashback"
              subtext={
                <div>
               
                  {/*D2C brands use discounts as a crutch for retention, training customers to wait for promotions.*/}
                  {" "}Setting up cashback on Shopify is simple and free. Just choose a cashback app from the Shopify app store, customize the cashback settings
                   (like the percentage or reward), and activate it. The integration is easy and doesn’t require any advanced technical skills.
                
                </div>
              }
          />


          {/*<CTABanner*/}
          {/*    text="Ready to start planning your cashback?" ctaURL="/pricing" ctaString="Select program"*/}
          {/*/>*/}

          {/*<div className="md:px-12">*/}
          {/*  <TestimonialsSection />*/}
          {/*</div>*/}

          <div className="">
            <ModernPricingView/>
          </div>
  
          <div className="mb-8 mt-2">
            <CarouselComponent />
          </div>
          </div>
          </div>
        </div>
       
  );
};

export default CashbackInfoComponent;
